import styled from 'styled-components';

import { fontSize, zIndex } from 'config/constants';

export const ALERT_BAR_HEIGHT = 40;
export const ALERT_BAR_OFFSET_VAR = '--alert-bar-offset';

export const Spacer = styled.div`
  flex-shrink: 0;
  height: ${ALERT_BAR_HEIGHT}px;
  width: 100%;
`;

export const Bar = styled.div`
  align-items: center;
  background: #f5e6a3;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.text.w500};
  display: flex;
  height: ${ALERT_BAR_HEIGHT}px;
  justify-content: center;
  left: 0;
  padding: 0 40px;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: ${zIndex.lv4};
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
  justify-content: center;
  max-width: 100%;
  min-width: 0;
`;

export const WarningIcon = styled.span`
  align-items: center;
  display: inline-flex;
  flex-shrink: 0;
  font-size: ${fontSize.xs};
  line-height: 1;
`;

export const Message = styled.p`
  font-size: ${fontSize.xs};
  font-weight: 700;
  line-height: 1.3;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 768px) {
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

export const CloseButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  color: inherit;
  cursor: pointer;
  display: inline-flex;
  font-size: ${fontSize.sm};
  height: 32px;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;

  &:hover {
    opacity: 0.75;
  }
`;
